class EPS {
    public id: number;
    public name_eps: string;
    public is_active: string;

    constructor(id: number, name_eps: string, is_active: string) {
        this.id = id;
        this.name_eps = name_eps;
        this.is_active = is_active;
    }
}
export default EPS;
